import * as Icons from "lucide-react";
import { PER_CHI } from "@/config/site";

export const PerChi = () => (
  <section className="bg-ivory py-20 lg:py-28" data-testid="perchi-section">
    <div className="container-ph">
      <div className="reveal max-w-xl">
        <span className="gold-line mb-5" />
        <h2 className="h-section">Per chi è Progetto HOSPITALITY?</h2>
      </div>
      <div className="mt-12 flex flex-wrap gap-3">
        {PER_CHI.map((p, i) => {
          const Icon = Icons[p.icon] || Icons.Circle;
          return (
            <span key={p.label} className={`reveal reveal-delay-${(i % 3) + 1} inline-flex items-center gap-2.5 border border-forest/25 bg-warm px-5 py-3 text-sm font-medium text-forest transition-colors duration-300 hover:border-bronze`} data-testid={`perchi-chip-${i + 1}`}>
              <Icon size={18} strokeWidth={1.5} className="text-bronze" />{p.label}
            </span>
          );
        })}
      </div>
    </div>
  </section>
);
